import React, { Component } from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'
export default class ColorPicker extends Component {
    constructor(props){
        super(props);
        this.state ={
            displayColorPicker: false,
             color:props.fColor
           
        }
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
      };
    
      handleClose = () => {
        this.setState({ displayColorPicker: false })
      };
    
      handleChange = (color) => {
        this.props.handleColor(color);
        this.setState({ color: color.hex })
      };
     
  render() {
    const styles = reactCSS({
        'default': {
          color: {
            width: '30px',
            height: '5px',
            borderRadius: '2px',
            background:this.props.fColor
          },
          swatch: {
            padding: '3px 5px',
            background: '#fff',
            display: 'inline-block',
            cursor: 'pointer',
            textAlign:'center',
            fontSize:'18px',
            border:'none',
            borderRadius:'5px'
          },
          popover: {
            position: 'absolute',
            zIndex: '2',
          },
          cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
          },
        },
      });
      return (
        <div>
          <div style={ styles.swatch } onClick={ this.handleClick }>
              A
            <div style={ styles.color } />
          </div>
          { this.state.displayColorPicker ? <div style={ styles.popover }>
            <div style={ styles.cover } onClick={ this.handleClose }/>
            <SketchPicker color={ this.props.fColor } onChange={ this.handleChange } />
          </div> : null }
  
        </div>
      )
    }
  
}
